'use client';

import type { IngestionPipeline } from '@repo/api-gw-sdk';
import { useCallback } from 'react';

import { DeleteEntityDialog } from '@/components/lakehouse/deleteEntityDialog';
import { useDAL } from '@/contexts/useDAL';

interface DeleteIngestionPipelineDialogProps {
  pipeline: IngestionPipeline;
  workspaceId: string;
  open: boolean;
  onClose: () => void;
  onDeleted: () => void;
}

export const DeleteIngestionPipelineDialog = ({
  pipeline,
  workspaceId,
  open,
  onClose,
  onDeleted,
}: DeleteIngestionPipelineDialogProps) => {
  const dal = useDAL();

  const handleDelete = useCallback(async () => {
    await dal.lakehouse.deleteIngestionPipeline(workspaceId, pipeline.id);
    onDeleted();
  }, [dal, workspaceId, pipeline.id, onDeleted]);

  return (
    <DeleteEntityDialog
      open={open}
      title='Delete Ingestion Pipeline'
      entityLabel='ingestion pipeline'
      entityName={pipeline.name}
      onClose={onClose}
      onDelete={handleDelete}
      testIdPrefix='confirm-delete-pipeline'
    />
  );
};
